import type { dateRangeDto } from 'commons';
import type { DtisZoomEvent } from '../../../../components/dtis-multilane-chart/zoomEvent';

export type TimeRange = { startTime: Date; endTime: Date };

/** Parses a value into a valid Date, returning undefined for null/invalid input. */
export function toValidDate(value: string | number | Date | undefined): Date | undefined {
  if (value === undefined || value === null) {
    return undefined;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? undefined : value;
  }

  const asNumber = Number(value);
  const candidate = Number.isNaN(asNumber) ? new Date(value) : new Date(Math.round(asNumber));

  return Number.isNaN(candidate.getTime()) ? undefined : candidate;
}

/** Resolves the time range of the currently active (non-vertical) zoom slider. */
export function getActiveZoomRange(zoomState: DtisZoomEvent[], lastZoomedId: string | undefined): TimeRange | undefined {
  const activeZoomState = zoomState.filter((zs) => !zs.dataZoomId.includes('vertical')).find((zs) => zs.dataZoomId === lastZoomedId) ?? zoomState[0];

  const startTime = toValidDate(activeZoomState?.startValue);
  const endTime = toValidDate(activeZoomState?.endValue);

  if (!startTime || !endTime) {
    return undefined;
  }

  return { startTime, endTime };
}

/** Resolves the time range to use for export/display: active zoom window first, falling back to the view's date range. */
export function getExportTimeRange(zoomState: DtisZoomEvent[], lastZoomedId: string | undefined, dateRange: dateRangeDto | undefined): TimeRange | undefined {
  const zoomRange = getActiveZoomRange(zoomState, lastZoomedId);
  if (zoomRange) {
    return zoomRange;
  }

  const startTime = toValidDate(dateRange?.start_date);
  const endTime = toValidDate(dateRange?.end_date);

  if (!startTime || !endTime) {
    return undefined;
  }

  return { startTime, endTime };
}
